module.exports = __webpack_public_path__ + "static/media/PE.65b299db.png";